export function formatNumberBR(value) {
    if (value == null || Number.isNaN(Number(value))) return '—';
    return Number(value).toLocaleString('pt-BR');
}

export function formatCurrencyBRL(value) {
    if (value == null || Number.isNaN(Number(value))) return '—';
    return Number(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
}

export function formatCompactCurrency(value) {
    if (value == null || Number.isNaN(Number(value))) return '';
    const amount = Number(value);
    if (amount >= 1000000) {
        const millions = amount / 1000000;
        const formatted = Number.isInteger(millions)
            ? millions.toFixed(0)
            : millions.toFixed(1).replace('.', ',');
        return `R$ ${formatted} mi`;
    }
    if (amount >= 1000) {
        return `R$ ${(amount / 1000).toFixed(0)}k`;
    }
    return `R$ ${amount}`;
}

export function formatDateBR(value) {
    if (!value) return '—';
    return new Date(value).toLocaleDateString('pt-BR');
}

export function formatMonthYear(value) {
    if (!value) return '—';
    const [year, month] = String(value).split('-');
    if (!year || !month) return '—';
    return `${month}/${year}`;
}

export function systemLabel(row) {
    if (!row) return '—';
    if (row.typeSystem === 2) return 'Weflix';
    if (row.typeBusiness === 1) return 'Weeduc · Escolar';
    if (row.typeBusiness === 2) return 'Weeduc · Corporativo';
    return 'Weeduc';
}

export function systemName(typeSystem) {
    return Number(typeSystem) === 2 ? 'Weflix' : 'Weeduc';
}

export function businessName(row) {
    if (!row || Number(row.typeSystem) === 2) return '—';
    if (Number(row.typeBusiness) === 1) return 'Escolar';
    if (Number(row.typeBusiness) === 2) return 'Corporativo';
    return '—';
}

export const MONTH_LABELS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
